import React, { useEffect } from 'react'

import AfterSaleSkeleton from 'common/components/skeleton/afterSale'
import { useQueryParams } from 'common/hooks/useQueryParams'
import ModulesRoutes from 'modules'
import { Switch } from 'wouter'

import TransitionManager from '../common/components/transitionManager'

const NavBarSection = React.lazy(() => import('common/components/navBar'))
const BottomSheetSection = React.lazy(() => import('common/components/bottomSheet'))
const RoutesComponent: React.FC = () => {
  const { handleQueryParams } = useQueryParams()

  useEffect(() => {
    handleQueryParams()
  }, [handleQueryParams])

  return (
    <React.Suspense fallback={<AfterSaleSkeleton />}>
      <TransitionManager>
        <NavBarSection />
        <Switch>
          <ModulesRoutes />
        </Switch>
      </TransitionManager>
      <BottomSheetSection />
    </React.Suspense>
  )
}

export default RoutesComponent
